export { NgxDocViewerComponent } from './document-viewer.component';
export { NgxDocViewerModule } from './document-viewer.module';
